import React, { useEffect, useState } from "react";
import "./css/style.css";
import myImg from "./img/street-view.png";
import cityImg from "./img/5.png";
import sunImg from "./img/2.png";
import DateTime from "./DateTime";
// import dotenv, { config } from "react-dotenv";
// dotenv.config({ path: "../config.env" });
// const { APPID } = config.env;

const Tempapp = () => {
  const [city, setCity] = useState(null);
  const [search, setSearch] = useState("Pune");

  useEffect(() => {
    const fetchApi = async () => {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${search}&units=metric&appid=231f8de70946792fa739e40362e185f3`;
      const response = await fetch(url);
      const resjson = await response.json();
      setCity(resjson.main);
    };
    fetchApi();
    // console.log(city);
  }, [search]);
  return (
    <>
      {/* <img src={weatherImg} className=" weather" alt="img" /> */}
      <h1 className="title">
        Check Weather Of Your City
        <span>
          <img src={cityImg} className="street-view" alt="img" />
        </span>
      </h1>
      <div className="box">
        {/* <i className="fa-solid fa-globe"></i> */}
        <div className="inputData">
          <input
            type="search"
            placeholder="Enter the city name, Eg:Pune"
            className="inputField"
            onChange={(event) => {
              setSearch(event.target.value);
            }}
          />
        </div>

        {!city ? (
          <h1>No Data Found</h1>
        ) : (
          <div>
            <div id="weathercon">
              {/* <img src={weatherImg} className="weather" alt="img" /> */}
              <img src={sunImg} className="sun" alt="img" />
              {/* <img src={cloudImg2} className="cloud2" alt="img" />
              <img src={cloudImg1} className="cloud1" alt="img" /> */}
            </div>
            <div className="info">
              <h2 className="location">
                <img src={myImg} className="street-view" alt="img" />
                {search}
              </h2>
              <h1 className="temp">{city.temp}&deg;C</h1>
              <h3 className="tempmin_max">
                Min: {city.temp_min}&deg;C | Max: {city.temp_max}
                &deg;C
              </h3>
              <DateTime />
            </div>
            <div className="wave -one"></div>
            <div className="wave -two"></div>
            <div className="wave -three "></div>
            <div className="wave wave-1 -one"></div>
            <div className="wave wave-1 -two"></div>
            <div className="wave wave-1 -three "></div>
          </div>
        )}
      </div>
    </>
  );
};

export default Tempapp;
